document.addEventListener('DOMContentLoaded', function() {
  const menuMobileToggleButtons = document.querySelectorAll('.menu-mobile-toggle');
  
  menuMobileToggleButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      document.body.classList.toggle('noscroll');
      
      const mastheadBlog = document.querySelector('#masthead-blog.blog-header');
      if (mastheadBlog) {
        mastheadBlog.classList.toggle('blog-mobile-menu-open');
      }
      
      const siteBlogContentArticle = document.querySelector('.site-blog-content-article');
      if (siteBlogContentArticle) {
        document.body.classList.toggle('desktop-scroll');
        siteBlogContentArticle.classList.toggle('blog-menu-open');
      }
    });
  });

  window.addEventListener('resize', function() {
    if (document.getElementById('menu-mobile-toggle')) {
      document.getElementById('menu-mobile-toggle').checked = false;
      document.body.classList.remove('noscroll');
    }
    if (document.getElementById('blog-category-menu-toggle')) {
      document.getElementById('blog-category-menu-toggle').checked = false;
      document.body.classList.remove('noscroll');
    }
    if (document.getElementById('masthead-blog')) {
      document.getElementById('menu-mobile-toggle').checked = false;
      document.getElementById('masthead-blog').classList.remove('blog-mobile-menu-open');
    }
    if (document.getElementById('content')) {
      document.getElementById('content').classList.remove('blog-menu-open');
    }
  });
});



function openSubmenu(){
    const menuAttr = this.getAttribute("menu");
    var columnSubmenus = document.getElementsByClassName("column-2-submenu");
    

    for (var i = 0; i < columnSubmenus.length; i++) {            
        columnSubmenus[i].classList.remove("active");
    }

    if(menuAttr) {
      const openSubmenu = document.getElementsByClassName("submenu-" + menuAttr)[0] 
      openSubmenu.classList.add("active");
    }    
}

function preOpenSubMenu(){    
  const submenuAttr = this.getAttribute("submenu");

  var columnSubmenus = document.getElementsByClassName("column-2-submenu");
    

  for (var i = 0; i < columnSubmenus.length; i++) {            
      columnSubmenus[i].classList.remove("active");
  }

  if(submenuAttr) {
    const openSubmenu = document.getElementsByClassName("mega-menu-" + submenuAttr)[0];
    
    const submenuItem = openSubmenu.querySelector('.has-submenu')

    const menuAttr = submenuItem.getAttribute("menu");      
    
    if(menuAttr) {
      const openSubmenu = document.getElementsByClassName("submenu-" + menuAttr)[0] 
      openSubmenu.classList.add("active");
    } 
  }  
}

window.addEventListener("load", (event) => {      
    var megaMenuHoverElements = document.getElementsByClassName("industry-link");
    var megaMenuElements = document.getElementsByClassName("mega-hover");
    var companyMenu = document.getElementById("companyMegaMenu");      

    if(companyMenu) {
      var companyMenuElements = companyMenu.querySelectorAll('.menu-item')      

      for (var i = 0; i < companyMenuElements.length; i++) {           
        companyMenuElements[i].addEventListener('mouseenter', openSubmenu, false);
      }
    }

    for (var i = 0; i < megaMenuElements.length; i++) {            
      megaMenuElements[i].addEventListener('mouseenter', preOpenSubMenu, false);
    }

    for (var i = 0; i < megaMenuHoverElements.length; i++) {            
        megaMenuHoverElements[i].addEventListener('mouseenter', openSubmenu, false);
    }    
})